<template>
    <div class="cardSection">
        <div class="cardCol">
            <div class="form-row">
                <div class="col-4">
                    <div class="cardStyle">
                        <VueSvgGauge
                            :start-angle="-110"
                            :end-angle="110"
                            :value="this.speed"
                            :separator-step="1"
                            :min="0"
                            :max="5"
                            :gauge-color="[{ offset: 0, color: '#347AB0'}, { offset: 100, color: '#799B29'}]"
                            :scale-interval="0"
                        />
                        <span>{{this.speed.toFixed(1)}} m/s</span>
                        <h4>{{ $t("global.speed")}}</h4>
                    </div>
                </div>
                <div class="col-4">
                    <div class="cardStyle centerIcon">
                        <i class="material-icons big-arrow">{{drivingArrow}}</i>
                        <span>{{ $store.state.chat.drivingDirection }}</span>
                        <h4>Direction</h4>
                    </div>
                </div>
                <div class="col-4">
                    <div class="cardStyle">
                        <VueSvgGauge
                        :start-angle="-110"
                        :end-angle="110"
                        :value="this.battery"
                        :separator-step="20"
                        :min="0"
                        :max="100"
                        :gauge-color="[{ offset: 0, color: '#B31F24'}, { offset: 40, color: '#799B29'}]"
                        :scale-interval="0"
                        />
                        <span>{{parseMinutes}}</span>
                        <h4>{{ $t("global.battery")}}</h4>
                    </div>
                </div>
            </div>
        </div>
        <div class="cardCol2">
            <div class="form-row">
                <div class="col-4">
                    <div class="cardStyle2">
                        <span>Cpu: {{cpu}}</span>
                    </div>
                </div>
                <div class="col-4">
                    <div class="cardStyle2">
                        <span>{{ $t("global.mem")}}: {{memory}}</span>
                    </div>
                </div>
                <div class="col-4">
                    <div class="cardStyle2">
                        <span>{{ $t("global.disk")}}: {{diskUsage}}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// @ is an alias to /src
import { mapState, mapActions } from 'vuex'
import { VueSvgGauge } from 'vue-svg-gauge'

export default {
  name: 'DataPanel',
  data() {
    return {
    }
  },
  components: {
    VueSvgGauge
  },
  computed: {...mapState({
    battery: state => state.chat.diagnostics.battery,
    timeLeft: state => state.chat.diagnostics.timeLeft,
    speed: state => state.chat.diagnostics.speed,
    diskUsage: state => state.chat.diagnostics.diskUsage,
    memory: state => state.chat.diagnostics.memory,
    cpu: state => state.chat.diagnostics.cpu,
    drivingDirection: state => state.chat.drivingDirection,
  }),
    drivingArrow() {
        if (this.drivingDirection == "Forward"){
            return "arrow_upward"
        }
        else{
            return "arrow_downward"
        }
    },
    parseMinutes(){
        
        let m = this.timeLeft % 60
        let h = (this.timeLeft-m)/60
        return h.toString() + ":" + (m<10?"0":"") + m.toString()
    }
  },

}
</script>

<style scoped>
    .big-arrow{
        font-size: 83px;
        color: #799B29;
        line-height: 0.65;
    }
</style>